'use client'

import { Select } from 'antd'
import { SBDynamicFormInput } from './types'

const SBDynamicFormInputSelect: SBDynamicFormInput = ({ item, ...rest }) => {
  return (
    <Select
      {...rest}
      listHeight={250}
      listItemHeight={10}
      options={item.options?.map((option) => ({
        value: option.id,
        label: option.label,
      }))}
      mode={item.max && item.max > 1 ? 'multiple' : undefined}
      maxCount={item.max && item.max > 1 ? item.max : undefined}
    />
  )
}

export { SBDynamicFormInputSelect }
